import Head from "next/head";
import ProjectList from "../../components/Lists/ProjectList";
import FeaturedNews from "../../components/Lists/FeaturedNews";
import {redirectTo500} from "../../utils/utility";
import ghost from "../../utils/ghost";

export async function getStaticProps(context) {
    const featuredData = await ghost({
        filter: "tags:news" + "+featured:true",
        pagination:{limit:3}
    });
    const listPagedData = await ghost({
        filter: "tags:news" + "+featured:false",
        pagination:{limit:"all"}
    });

    if (!featuredData || !listPagedData) {
        return redirectTo500();
    }

    return {
        props: {
            featured: featuredData,
            listPaged: listPagedData,
        },
        revalidate: 3600,
    };
}

const News = props => {
    return (
        <>
            <Head>
                <title>News | Top Software Company in Bangladesh</title>
                <meta
                    name="description"
                    content="Check out our news page and get updates on what is happening at DSi."
                />
            </Head>
            <div className="bg-white w-full pt-8 sm:pt-16">
                <div className="grid mid-home-column items-center">
                    <h2 className="text-black font-headline items-center break-words text-center font-normal text-6xl mb-1">
                        Our News
                    </h2>
                </div>
            </div>

            {/* featured */}
            <div className="bg-white w-full py-10 sm:py-20">
                <div className="grid mid-home-column ">
                    <div className="pb-12 items-center flex flex-col mx-5">
                        <h2 className="text-black font-headline items-center break-words text-center font-extrabold text-3xl md:text-4xl mb-1">
                            Featured
                        </h2>
                        <p className="text-center flex font-headline items-center text-base md:text-xl leading-8 text-gray-600">
                            What's happening in DSi
                        </p>
                    </div>
                    <div className="flex mx-5">
                        <FeaturedNews
                            how={props.featured.posts}
                            path="/news/"
                            title="VIEW ARTICLE"
                        />
                    </div>
                </div>
            </div>

            <div className="w-full pb-9 md:pt-8 md:pb-28 flex">
                <div className="grid mid-home-column mid-column">
                    <div className="pb-12 items-center flex flex-col">
                        <h2 className="text-black font-headline items-center break-words text-center font-extrabold text-3xl md:text-4xl mb-1">
                            Other Major News
                        </h2>
                        <p className="text-center flex font-headline items-center text-base md:text-xl leading-8 text-gray-600">
                            Catch up with us!
                        </p>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-1 md:grid-rows-1 mx-5">
                        <ProjectList
                            data={props.listPaged.posts}
                            title="VIEW ARTICLE"
                            path="/news/"
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default News;
